import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-upload-validation-modal',
    templateUrl: './upload-validation-modal.component.html',
    styleUrls: ['./upload-validation-modal.component.scss']
})
export class UploadValidationModalComponent {
    constructor(
        public dialogRef: MatDialogRef<UploadValidationModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}
}
